<template>
  <div class="message">
    <!-- <cube-scroll ref="scroll" :data="speak"> -->
      <div class="message-box" v-for="(item,i) in speak" :key="i">
        <div class="message-img"><img :src="item.user.portrait"></div>
        <div class="message-info">
          <div class="message-info-name">{{item.user.name}}</div>
          <div class="message-info-text">{{item.content | expression}}</div>
        </div>
      </div>
    <!-- </cube-scroll> -->
  </div>
</template>

<script>
  import { appkey } from '@/api/path.js'
  import { wxshare, secondToDate } from '@/utils/utils.js'
  import { sharevideolive, getendtime } from '@/api/resetApi.js'

  export default {
    name: 'liveBroadcast',
    inject: ['reload'],
    data(){
      return{
        appkey:appkey,
        speak: [],
        emojiList: [],
        token: '',
        chatRoomId: '10010',
      }
    },
    created(){
      // console.log('appkey=',this.appkey)
      this.token = this.$route.query.token
      this.chatRoomId = this.$route.query.room_id;
      this.client()
    },
    methods: {
      // 连接融云聊天室
      client() {
        let that = this
        // 表情包
        // RongIMLib.RongIMEmoji.init();
        // that.emojiList = RongIMLib.RongIMEmoji.list;
        // console.log('表情',that.emojiList)

        // 初始化
        RongIMLib.RongIMClient.init(that.appkey);

        // 状态监听器
        RongIMClient.setConnectionStatusListener({
          onChanged: function (status) {
            // status 标识当前连接状态
            switch (status) {
              case RongIMLib.ConnectionStatus.CONNECTED:
                console.log('链接成功');
                break;
              case RongIMLib.ConnectionStatus.CONNECTING:
                console.log('正在链接');
                break;
              case RongIMLib.ConnectionStatus.DISCONNECTED:
                console.log('断开连接');
                break;
              case RongIMLib.ConnectionStatus.KICKED_OFFLINE_BY_OTHER_CLIENT:
                console.log('其他设备登录, 本端被踢');
                break;
              case RongIMLib.ConnectionStatus.DOMAIN_INCORRECT:
                console.log('域名不正确, 请至开发者后台查看安全域名配置');
                break;
              case RongIMLib.ConnectionStatus.NETWORK_UNAVAILABLE:
                console.log('网络不可用, 此时可调用 reconnect 进行重连');
                break;
              default:
                console.log('链接状态为', status);
                break;
            }
          }
        });

        // 消息监听器
        RongIMClient.setOnReceiveMessageListener({
          // 接收到的消息
          onReceived: function (message) {
            var messageContent = message.content;
            // console.log('1111111111111')
            // 判断消息类型
            switch(message.messageType) {
              case RongIMClient.MessageType.TextMessage: // 文字消息
                that.speak.push(messageContent)
                console.log('表情', RongIMLib.RongIMEmoji.symbolToEmoji(messageContent.content));
                console.log('文字内容', messageContent.content);
                console.log('集合', that.speak);
                break;
              case RongIMClient.MessageType.ImageMessage: // 图片消息
                console.log('图片缩略图 base64', messageContent.content); 
                console.log('原图 url', messageContent.imageUri);
                break;
              case RongIMClient.MessageType.HQVoiceMessage: // 音频消息
                console.log('音频 type ', messageContent.type); // 编解码类型，默认为 aac 音频
                console.log('音频 url', messageContent.remoteUrl); // 播放：<audio src={remoteUrl} />
                console.log('音频 时长', messageContent.duration);
                break;
              case RongIMClient.MessageType.RichContentMessage: // 富文本(图文)消息
                console.log('文本内容', messageContent.content);
                console.log('图片 base64', messageContent.imageUri);
                console.log('原图 url', messageContent.url);
                break;
              case RongIMClient.MessageType.UnknownMessage: // 未知消息
                console.log('未知消息, 请检查消息自定义格式是否正确', message);
                break;
              default:
                console.log('收到消息', message);
                break;
            }
          }
        });

        // 连接接口
        let token = that.token
        // 开发者后台获取或 Server API 
        RongIMClient.connect(token, {
          onSuccess: function(userId) {
            console.log('Connect successfully. ' + userId);
            that.chatRoom()
          },
          onTokenIncorrect: function() {
            console.log('token 无效');
          },
          onError: function(errorCode){
            var info = '';
            switch (errorCode) {
            case RongIMLib.ErrorCode.TIMEOUT:
              info = '超时';
              break;
            case RongIMLib.ConnectionState.UNACCEPTABLE_PAROTOCOL_VERSION:
              info = '不可接受的协议版本';
              break;
            case RongIMLib.ConnectionState.IDENTIFIER_REJECTED:
              info = 'appkey不正确';
              break;
            case RongIMLib.ConnectionState.SERVER_UNAVAILABLE:
              info = '服务器不可用';
              break;
            }
            console.log('33333=',info);
          }
        });

        
      },
      // 加入聊天室
      chatRoom() {
        var chatRoomId = this.chatRoomId;
        var count = 10;
        RongIMClient.getInstance().joinChatRoom(chatRoomId, count, {
          onSuccess: function() {
            console.log('加入聊天室成功'); 
          },
          onError: function(error) {
            console.log('加入聊天室失败', error);
          }
        });
      }
    }
  }
</script>

<style lang="scss">
  .message {
    max-width: 780px;
    margin: 0 auto;
    background: #f4f4f4;
    // height: 2.7rem;
    .message-box {
      display: flex;
      padding: 0.1rem;
      font-size: 0;
      .message-img {
        flex: 0 0 0.3rem;
        img {
          width: 0.3rem;
          height: 0.3rem;
          border-radius: 50%;
          vertical-align: top;
        }
      }
      .message-info {
        flex: 1;
        margin-left: 0.05rem;
        display: flex;
        border-radius: 0.12rem;
        font-size: 0;
        background: #fff;
        .message-info-name {
          flex: 0 0 0.4rem;
          padding: 0.12rem 0.05rem;
          align-self: top;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          text-align: left;
          // vertical-align: top;
          font-size: 0.12rem;
          color: #707070;
        }
        .message-info-text {
          flex: 1;
          padding: 0.1rem 0.05rem;
          line-height: 0.15rem;
          text-align: left;
          align-self: center;
          font-size: 0.12rem;
          color: #252525;
        }
      }
    }
  }
</style>